import axios from "axios";

const VOUCHER_API_URL = `${process.env.REACT_APP_VOUCHERS_API_URL}/api/v2/voucherApi`;
// const VOUCHER_API_URL = "http://127.0.0.1:3000/api/v2/voucherApi";

export const fetchVouchers = async () => {
	const payload = {
		"filters" : {}
	};

	const response = await axios.post(VOUCHER_API_URL, payload);
	return response.data;
};
